import { LanguageType } from '@/models/LanguageType';

export enum ClassificationsTypes {
    GET_CLASSIFICATIONS_REQUEST = '@classification/GET_CLASSIFICATIONS_REQUEST',
    GET_CLASSIFICATIONS_SUCCESS = '@classification/GET_CLASSIFICATIONS_SUCCESS',
    GET_CLASSIFICATIONS_FAILURE = '@classification/GET_CLASSIFICATIONS_FAILURE',
}

export interface Classification {
    id: number;
    name: string;
    description: string;
    organizationId: number;
    applicationId: number;
    locale: LanguageType;
    isSelected: boolean;
}

export interface ClassificationsState {
    data: { classificationsList: Classification[] };
    hasError: boolean;
    loading: boolean;
}
